import { memo } from "react";

import { Template } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useTemplatesTableStore from "./useTemplatesTableStore";
import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { TEMPLATES_WORKBENCH_TABLE_CELLS } from "./Cells";
import { TEMPLATES_WORKBENCH_SORT_CONFIG } from "./constants";

type TemplatesTableProps = {
  templates: Template[];
  loading?: boolean;
  rowsPerPage: number;
};

const TemplatesTable = ({ templates, loading, rowsPerPage }: TemplatesTableProps) => {
  return (
    <TableSimple
      data={templates}
      loading={loading}
      store={useTemplatesTableStore}
      ariaLabel="Templates table"
      rowsPerPage={rowsPerPage}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      cellPerColumn={TEMPLATES_WORKBENCH_TABLE_CELLS}
      sortConfig={TEMPLATES_WORKBENCH_SORT_CONFIG}
      hasPagination
    />
  );
};

export default memo(TemplatesTable);
